import React, { useMemo } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { checklistMessages as messages } from './checklistMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the checklist; each part uses its own slice of it */
import styles from './FirstReleaseChecklist.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ChecklistProgressProps {
  done: number;
  total: number;
  /** The small ring of the sidebar pill: no number inside. */
  small?: boolean;
  title?: string;
}

/** The progress ring with "3/10" in it (design: onboarding d1, d5, d6). */
const ChecklistProgressComponent: React.FC<ChecklistProgressProps> = ({ done, total, small = false, title }) => {
  const intl = useIntl();
  const label = intl.formatMessage(messages.progress, { done, total });
  const style = useMemo(
    () => ({ '--p': `${total === 0 ? 0 : Math.round((done / total) * 100)}%` }) as React.CSSProperties,
    [done, total]
  );

  return (
    <span
      className={clsx(styles.ring, small && styles.ringSmall)}
      style={style}
      role="img"
      aria-label={label}
      title={title}
      data-testid="checklist-progress"
    >
      <span className={styles.ringInner}>{small ? null : label}</span>
    </span>
  );
};

export const ChecklistProgress = TypedMemo(ChecklistProgressComponent);
